// Assessment overview section form field enum
export enum AssessmentOverviewFormField {
  APPOINTMENT_TIME = 'appointmentTime'
}
